export const CODES = {
  OPENED: 0,
  NOTHING: -1,
  FLAG: -2,
  QUESTION: -3,
  MINE: -4,
  MINE_FLAG: -5,
  MINE_QUESTION: -6,
};
